export const SET_TAG = "SET_TAG";

export const setTag = (tag) => ({type: SET_TAG, tag});
